import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import HighFiveHands from 'common/illustrations/HighFiveHands';
import { Typography as T } from 'common/typography';

const Illustration = styled(HighFiveHands)`
  display: block;
  width: 260px;
  height: auto;
  margin-block-end: 32px;
`;

const Heading = styled(T.Heading1)`
  margin-block-end: 32px;
  text-align: center;
`;

const Body = styled(T.Body1)`
  display: block;
  text-align: center;
`;

const ThankYouScreen = () => {
  return (
    <>
      <Illustration />
      <Heading>
        <FormattedMessage id="venue-data-collection.submission-complete.heading" />
      </Heading>
      <Body>
        <FormattedMessage id="venue-data-collection.submission-complete.body" />
      </Body>
    </>
  );
};

export default ThankYouScreen;
